// ReportCard.jsx
import React, { useState, useEffect } from "react";
import "../Reports.scss";
import { IconControl, ToastNotifications } from "spark-core-dx/components";
import { ReportingIFrame } from "./ReportingIFrame";
import ReportingPowerBI from "./ReportingPowerBI";
import { useReportsDomainContext } from "../ReportsDomainProvider";
import { useCoreContext } from "spark-core-dx/contexts";

const ReportCard = ({}) => {
  const { reports, id } = useReportsDomainContext();
  const coreContext = useCoreContext();

  const [report, setReport] = useState(null);
  const [toasterMessage, setToasterMessage] = useState(null);

  const shareUrl = `${window.location.origin}/reports/${id}`;

  useEffect(() => {
    if (!reports || !id) return;
    const found = reports.find((x) => x._id === id);
    setReport(found || null);
  }, [reports, id]);

  const handleShare = (shareLink) => {
    navigator.clipboard.writeText(shareLink);
    setToasterMessage("Share link has been saved to your clipboard.");
    setTimeout(() => setToasterMessage(null), 6000);
  };

  const renderReportBody = (r) => {
    if (!r) return null;

    // ReportType: 1 = SSRS (iframe), 2 = Power BI embed
    if (Number(r.ReportType) === 2) {
      return (
        <ReportingPowerBI
          tenantId={coreContext?.AZTenantId}
          clientId={coreContext?.AZReportingAppClientId}
          report={r}
        />
      );
    }

    // default SSRS
    return <ReportingIFrame reportId={r?._id} />;
  };

  return (
    <div className="report-card">
      {toasterMessage && (
        <ToastNotifications position="top" message={toasterMessage} />
      )}

      <div className="report">
        <div className="report__header">
          <div className="report__header-title">
            <h3>{report?.Name}</h3>
            {!!report?.Description && (
              <div className="report__header-subtitle">{report.Description}</div>
            )}
          </div>

          <div className="report__header-button-container">
            <IconControl
              iconKey="share"
              title="Share"
              onClick={() => handleShare(shareUrl)}
            />
          </div>
        </div>

        <div className="report__inner">{renderReportBody(report)}</div>
      </div>
    </div>
  );
};

export default ReportCard;
